import type { CSSProperties } from 'react';
import {
  LayeredContentItemProps,
  LayeredContent,
} from '@designsystem/stories/04-organisms/LayeredContent';
import { normalizeContent } from '@fhnw/helpers/DesignSystem/normalizeContent';

export interface BlockDataProps {
  items?: any[];
}

interface ViewProps {
  data: BlockDataProps;
}

const isOriginalImageMedia = (media?: any) => {
  const format = media?.format?.toString().toLowerCase();
  return (
    media?.media_type === 'image' &&
    (!format || format === 'none' || format === 'original')
  );
};

const getImageWidth = (media?: any) => {
  const image = media?.image;
  const imageScales = image?.image_scales;
  const field = image?.image_field || 'image';
  const scale = imageScales?.[field]?.[0] || imageScales?.image?.[0];
  const width = Number(scale?.width);

  return Number.isFinite(width) && width > 0 ? width : undefined;
};

const withOriginalImageMaxWidths = (
  groups: LayeredContentItemProps[],
  items: any[],
) =>
  groups.map((group, index) => {
    const width = getImageWidth(items[index]?.media);

    if (!group.media || !isOriginalImageMedia(items[index]?.media) || !width) {
      return group;
    }

    return {
      ...group,
      media: {
        ...group.media,
        originalSize: true,
        style: {
          ...(group.media.style as CSSProperties),
          maxWidth: `min(100%, ${width}px)`,
        },
      },
    };
  });

const View = (props: ViewProps) => {
  const { items } = props.data;

  if (!items || !items.length) {
    return null;
  }

  const normalizedGroups = normalizeContent(items, true, {
    '40rem': '100vw',
    '106rem': '50vw',
    max: '53rem',
  }) as LayeredContentItemProps[];

  return (
    <LayeredContent
      groups={withOriginalImageMaxWidths(normalizedGroups, items)}
    />
  );
};

export default View;
